module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TT-52b3b292634f47a44ea7b9ce5fc3e923.png";